import axios from 'axios';

import { apiAuth, generateTokenStructure, requestConfig } from './index';
import authParams from './authParams';

/**
 * Response: {
 *  gender: bool
 *  birthday: string(yyyy/mm/dd)
 *  image: string
 *  email: string
 *  firstName: string
 *  lastName: string
 *  username: string(mobile)
 *  roles: [int]
 *  userStateId: int
 * }
 */
export const fetchUserProfile = async () => {
	try {
		const { data } = await apiAuth.get(`/user/profile`);
		return data;
	} catch (e) {
		throw e;
	}
};

/**
 * Request: {
 *  gender: bool(true:male, false:female, null)
 *  firstName: string
 *  lastName: string
 *  email: string
 *  birthday: string(yyyy/mm/dd)
 * }
 */
export const updateUserProfile = (data) =>
	apiAuth.put('user/update', {
		...authParams,
		...data,
	});

/**
 * Response: [{
 *  id
 *  address
 *  isDefault
 *  cityName
 * }]
 */
export const fetchUserAddressList = async () => {
	try {
		const { data } = await apiAuth.get(`user/getUserAddressList`);
		return data;
	} catch (e) {
		throw e;
	}
};

export const userChangePassword = (currentPassword, newPassword) =>
	apiAuth.put('user/changePassword', {
		...authParams,
		currentPassword,
		newPassword,
	});

export const validateUserAccount = async (code, companyDomain) => {
	try {
		const { data } = await apiAuth.post(`/user/validate`, {
			code,
			companyDomain,
		});
		return data;
	} catch (e) {
		throw e;
	}
};

export const initUserMobile = async (code, companyDomain, username, token) => {
	try {
		const instanceApi = axios.create(requestConfig);
		instanceApi.defaults.headers.common.Authorization = generateTokenStructure(
			token,
		);

		const { data } = await instanceApi.put(`/user/initialize`, {
			code,
			companyDomain,
			username,
		});
		return data;
	} catch (e) {
		let data = {};
		data.error = e.status
			? `error: ${e.status}`
			: 'خطا در برقراری ارتباط با سرور';
		if (e.response) {
			if (e.response.status === 401) {
				data.error = 'درخواست شما منقضی شده است، مجددا تلاش کنید';
				data.errStatus = 401;
			} else {
				data = e.response.data;
				data.error = data.message;
			}
		}
		throw data;
	}
};

/**
 * Response: {
 *  credit: int
 * }
 */
export const fetchUserCredit = async () => {
	try {
		const { data } = await apiAuth.get(`/UserCredit/GetItem`);
		return data;
	} catch (e) {
		throw e;
	}
};

export const fetchUserPeymentToken = async (id) => {
	try {
		const { data } = await apiAuth.post(`/userCredit/addOnline`, {
			dayId: id,
		});
		return data;
	} catch (e) {
		throw e;
	}
};

export const fetchUserOrders = async (month, year) => {
	try {
		const { data } = await apiAuth.get(
			`/user/GetUserInvoicesMonth?month=${month}&year=${year}`,
		);

		return data;
	} catch (e) {
		throw e;
	}
};
export const fetchUserTransactions = async (month, year) => {
	try {
		const {
			data: { value },
		} = await apiAuth.get(
			`/odata/bankTransaction?$filter=month eq ${month} &year eq ${year}&orderby=id%20desc`,
		);

		return value;
	} catch (e) {
		throw e;
	}
};
